import {SkeletonContext} from 'modules/skeleton/components/SkeletonWrapper';
import {useContext} from 'react';

export const useIsSkeleton = (): boolean => {
    return useContext(SkeletonContext);
};
